import { z } from "zod";
import { ContractVersionMetadataSchema } from "./contract-version.js";
export const CorrelationIdSchema = z
    .string()
    .min(1)
    .max(128)
    .brand();
export const OpaqueCursorSchema = z
    .string()
    .min(16)
    .max(2048)
    .regex(/^[A-Za-z0-9_-]+$/, "Expected an opaque base64url cursor")
    .brand();
export const ApiErrorCodeSchema = z.enum([
    "invalid_request",
    "unauthorized",
    "forbidden",
    "not_found",
    "conflict",
    "rate_limited",
    "service_unavailable",
    "internal_error",
]);
export const ApiErrorIssueSchema = z.object({
    field: z.string().min(1).max(128),
    code: z.string().min(1).max(64),
});
export const ApiErrorSchema = z.object({
    code: ApiErrorCodeSchema,
    message: z.string().min(1).max(512),
    correlationId: CorrelationIdSchema,
    retryable: z.boolean(),
    issues: z.array(ApiErrorIssueSchema).max(100).optional(),
});
export const ApiErrorEnvelopeSchema = z.object({ error: ApiErrorSchema });
export const ApiEnvelopeMetadataSchema = z.object({
    contract: ContractVersionMetadataSchema,
    correlationId: CorrelationIdSchema,
});
export const CursorPageMetadataSchema = z
    .object({
    limit: z.number().int().min(1).max(200),
    hasMore: z.boolean(),
    nextCursor: OpaqueCursorSchema.nullable(),
})
    .superRefine((page, context) => {
    if (page.hasMore !== (page.nextCursor !== null)) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            message: "nextCursor must be present exactly when hasMore is true",
            path: ["nextCursor"],
        });
    }
});
export function createApiEnvelopeSchema(dataSchema) {
    return z.object({
        data: dataSchema,
        meta: ApiEnvelopeMetadataSchema,
    });
}
export function createCursorPageSchema(itemSchema) {
    return z.object({
        data: z.array(itemSchema),
        meta: ApiEnvelopeMetadataSchema.extend({
            page: CursorPageMetadataSchema,
        }),
    });
}
//# sourceMappingURL=api.js.map